<template>
    <div>
        <BOverlay :show="is_load" rounded="sm">
            <div class="app_vue_list" >
                <!-- filter -->
                <div class="filter_block mb-3">
                    <tender_filter   v-model:filter="filter"
                                     @search_called="handleSearch"
                                     @clean_filter="handleCleanFilters"></tender_filter>
                </div>
                
                <BTable  :thead-class="head_class" responsive striped :items="rows" :fields="table_fields">
                    <!-- HEAD FIELDS -->
                    <template v-slot:head(id)="data">
                        <grid :list_ordering="'id'" field_name="ID" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(number)="data">
                        <grid :list_ordering="'number'" field_name="Номер" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(tender_type)="data">
                        <grid :list_ordering="'tender_type'" field_name="Тип" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(name)="data">
                        <grid :list_ordering="'name'" field_name="Назва" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(memoramdum_number)="data">
                        <grid :list_ordering="'memoramdum_number'" field_name="Службова" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_from)="data">
                        <grid :list_ordering="'date_from'" field_name="З" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_to)="data">
                        <grid :list_ordering="'date_to'" field_name="По" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(author_id)="data">
                        <grid :list_ordering="'author_id'" field_name="Створив" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(status)="data">
                        <grid :list_ordering="'status'" field_name="Статус" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(date_archive)="data">
                        <grid :list_ordering="'date_archive'" field_name="Дата статуса" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(c_app)="data">
                        <grid :list_ordering="'c_app'" field_name="Заявок" :current_ordering="list.ordering" :current_direction="list.direction" @update-order="handleOrdering"/>
                    </template>
                    
                    <template v-slot:head(remove_class)="data"></template>
                    <template v-slot:head(protocol_class)="data">Пр</template>
                    
                    <!-- body -->
                    <template v-slot:cell(number)="row">
                        <BTooltip>
                            <template #target>
                                <a class="href_blue" :href="'/tender/show/' + row.item.id" >
                                    {{row.item.number}}
                                </a>
                            </template>
                            Перегляд
                        </BTooltip>
                    </template>
                    
                    <template  v-slot:cell(tender_type)="data">
                        <div v-if="data.item.tender_type == 'first_simple'">
                            1 тур
                        </div>
                        
                        <div v-else-if="data.item.tender_type == 'second_reduction'">
                            Редукціон
                        </div>
                        
                        <div v-else-if="data.item.tender_type == 'second_simple'">
                            2 тур
                        </div>
                    </template>
                    
                    <template  v-slot:cell(name)="data">
                        <BTooltip>
                            <template #target>
                                <a  :href="'/tender/edit/' + data.item.id">
                                    {{data.item.name}}
                                </a>
                            </template>
                            Редагувати
                        </BTooltip>
                    </template>
                    
                    <template  v-slot:cell(memoramdum_number)="data">
                        <div style="max-width: 160px ">
                            {{memorandum_number(data.item.memoramdum_number)}}
                        </div>
                    </template>
                    
                    <template  v-slot:cell(date_from)="data">
                        {{fmtDate(data.item.date_from)}}
                    </template>
                    
                    <template  v-slot:cell(date_to)="data">
                        {{fmtDate(data.item.date_to_real)}}
                    </template>
                    
                    <template  v-slot:cell(author_id)="data">
                        {{data.item.owner?.name}}
                    </template>
                    
                    <template  v-slot:cell(status)="data">
                        <div v-if="data.item.status == 'new'">Новий</div>
                        <div v-else-if="data.item.status == 'published'">Опублікований</div>
                        <div v-else-if="data.item.status == 'archive'">Aрхів</div>
                        <div v-else>{{data.item.status}}</div>
                    </template>
                    
                    <template v-slot:cell(date_archive)="data">
                        <div v-if="data.item.status == 'archive'">{{fmtDate(data.item.date_archive)}}</div>
                        <div v-else>{{ fmtDate(data.item.memoramdum_approve_date) }}</div>
                    </template>
                    
                    <template  v-slot:cell(remove_class)="data">
                        <BTooltip>
                            <template #target>
                               <span class='icon-stack  text-center fs-xxl cursor-pointer'
                                     title="Видалити тендер" v-on:click="remove_doc(data.item)">
                                    <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                                    <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                                </span>
                            </template>
                            Видалити тендер
                        </BTooltip>
                    </template>
                    
                    <template  v-slot:cell(protocol_class)="data">
                        <BTooltip>
                            <template #target>
                               <span v-if="data.item.protocol_id"
                                     class='icon-stack  text-center fs-xxl cursor-pointer'
                                     v-on:click="protocol_show(data.item)"
                               >
                                    <i class="base base-1 icon-stack-3x opacity-100 color-success-600"></i>
                                    <i class="far fa-eye icon-stack-1x opacity-100 color-white"></i>
                                </span>
                                
                                <span v-else
                                      class='icon-stack  text-center fs-xxl cursor-pointer'
                                      v-on:click="protocol_doc(data.item)"
                                >
                                    <i class="base base-1 icon-stack-3x opacity-100 color-info-600"></i>
                                    <i class="far fa-file icon-stack-1x opacity-100 color-white"></i>
                                </span>
                            </template>
                            
                            <span v-if="data.item.protocol_id">
                                Переглянути протокол
                            </span>
                            <span v-else>
                                    Створити протокол
                            </span>
                        </BTooltip>
                        
                    </template>
                    
                </BTable>
            </div>
            
            <div class="pt-4" v-if="rows.length > 0">
                <pagination
                    key="down"
                    :total="pagination.total"
                    :limit="pagination.limit"
                    :current="pagination.pagesCurrent"
                    @page-change="handlePageChange">
                </pagination>
            </div>
        
        </BOverlay>
    </div>
</template>


<script>


import {
    BButton,
    BTable,
    BOverlay,
    BTooltip,
} from 'bootstrap-vue-next';

import grid from "../../../shared/list/grid/grid.vue";
import pagination from "../../../shared/list/pagination/pagination.vue";
import List_filter from "../../../shared/list/filter/list_filter.vue";
import tender_filter from "./tender_filter.vue";

export default {
    name: "tender_table",
    
    components : {
        List_filter,
        BTable,
        BOverlay,
        BButton,
        BTooltip,
        grid,
        pagination,
        tender_filter
    },
    props : {
        has_tender_all : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            rows : [],
            is_load : true,
            
            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30
            },
            
            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },
            
            filter: {
                search: "",
                provider_id: "",
                city_id: "",
                rest_group: ""
            },
            
            fields : [
                {key : 'number',label: 't.number ',class:''},
                {key : 'tender_type',label: 't.tender_type ',class:''},
                {key : 'name',label: 't.name ',class:''},
                {key : 'memoramdum_number',label: 't.memoramdum_number ',class:''},
                {key : 'date_from',label: 't.date_from ',class:''},
                {key : 'date_to',label: 't.date_to ',class:''},
                {key : 'author_id',label: 't.author_id ',class:''},
                {key : 'status',label: 't.status',class:''},
                {key : 'date_archive',label: 't.date_archive',class:''},
                {key : 'c_app',label: 'ca.num_applications',class:''},
                {key : 'remove_class',label: ' ',class:''},
                {key : 'protocol_class',label: ' ',class:''},
            ],
        }
    },
    
    mounted() {
        this.load_items();
    },
    
    created() {
    
    },
    
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY/MM/DD HH:mm:ss');
        }
    },
    
    methods : {
        
        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },
        
        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },
        
        handleSearch(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },
        
        handleCleanFilters() {
            
            this.filter = {
                search: "",
            };
            
            this.list = {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            
            this.list.start = 0;
            this.load_items();
        },
        
        edit_view(item) {
            if ((item.status == 'new') || (item.status == 'reject')) {
                window.location = this.href_edit + item.id;
            } else {
                window.location = this.href_view + item.id;
            }
        },
        
        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },
        
        async load_items() {
            this.is_load = true;
            this.rows = [];
            this.filter.has_tender_all = this.has_tender_all;
            
            
            await api.post('/tenders/sales/tenders',{
                filter  : this.filter,
                list    : this.list
            }).then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rows = data.data;
                    if (data.message?.pagination) {
                        this.pagination = data.message.pagination;
                    }
                }
            }).catch(response => {
                this.is_load = false;
                this.rows = [];
                
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        memorandum_number(number)
        {
            return  number.replace(/(;)/gi, ' ')
        },
        
        remove_doc(item) {
            let self = this;
            confirm_imc('Видалити?').then(res => {
                self.removeTender(item);
            });
        },
        
        async removeTender(item) {
            IMC_CORE.showloading();
            await api.delete('/tenders/sales/tenders/' + item.id,).then(({data}) => {
                IMC_CORE.hideloading();
                this.load_items();
            }).catch(response => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        },
        
        protocol_show(item) {
            window.location.href = "/protokoly/show/" + item.protocol_id;
        },
        
        protocol_doc(item) {
            window.location.href = "/protokoly/new/" + item.id;
        }
    },
    
    computed : {
        
        head_class() {
        },
        
        table_fields() {
            return this.fields;
        }
    }
    
}
</script>


<style scoped>

</style>